import { createSlice } from "@reduxjs/toolkit";
import { getDistribucionTalentosThunk } from "./distribucionTalentos.thunks";

const initialState = {
  distribucionTalentos: [],
  loading: false,
  error: null,
};

const distribucionTalentosSlice = createSlice({
  name: "distribucionTalentos",
  initialState,
  reducers: {
    clearDistribucionError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ================================
      // GET DISTRIBUCIÓN DE TALENTOS
      // ================================
      .addCase(getDistribucionTalentosThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDistribucionTalentosThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.distribucionTalentos = action.payload;
      })
      .addCase(getDistribucionTalentosThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDistribucionError } = distribucionTalentosSlice.actions;
export default distribucionTalentosSlice.reducer;
